<template>
    <div>
        <div v-for="(category, i) in categories" v-if="category.coffees && category.coffees.length">
            <h2 class="category-heading" :class="{'first-heading':i===0}">{{ category.heading }}</h2>
            <p class="category-sub-heading">{{ category.sub_heading }}</p>
            <coffee-card-list
                :coffees="category.coffees"
                :playlist-data="playlistData"
                :background-color-offset="i"
                :brewlist-detail="brewlistDetail"
                :buy-now-props="buyNowProps"
                :max-cards-per-row="category.heading === 'Holiday Coffees' ? 100 : 9"
                v-on:add-coffee-to-playlist="addCoffeeToPlaylist"/>
        </div>

        <transition name="fade">
            <div v-if="nonCategorizedCoffees.length">
                <h2 class="category-heading">Everything Else</h2>
                <p class="category-sub-heading">Every coffee on our platform is roasted fresh and sent directly from the roaster.</p>
                <coffee-card-list
                    :coffees="nonCategorizedCoffees"
                    :playlist-data="playlistData"
                    :brewlist-detail="brewlistDetail"
                    :buy-now-props="buyNowProps"
                    v-on:add-coffee-to-playlist="addCoffeeToPlaylist"
                />
            </div>
        </transition>

        <infinite-loading v-if="loadNonCategorizedCoffees" @infinite="loadMoreCoffees" spinner="circles">
            <span slot="no-more"></span>
            <span slot="no-results"></span>
        </infinite-loading>
    </div>
</template>

<script>
    import CoffeeCardList from "./coffee-card-list-home";
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            CoffeeCardList,
            InfiniteLoading
        },
        props: {
            categories: Array,
            playlistData: Object,
            brewlistDetail: Object,
            buyNowProps: Object,
            loadNonCategorizedCoffees: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                nonCategorizedCoffees: [],
                page: 1
            }
        },
        methods: {
            addCoffeeToPlaylist(coffeeId, size, grind) {
                this.$emit('add-coffee-to-playlist', coffeeId, size, grind);
            },
            loadMoreCoffees($state) {
                this.$api.get('/v1/coffees', this.exceptedIdsParam)
                    .then( res => {
                        if (!res.data || res.length === 0) {
                            $state.complete();
                        } else {
                            this.nonCategorizedCoffees.push(...res.data);
                            $state.loaded();
                        }
                        this.page++;
                    })
                    .catch(console.error);
            },
            // Implementation of JS array.flat() as IE doesn't support it...
            flat(arr) {
                if (!arr) {
                    return []
                }

                return arr.reduce((acc, val) => acc.concat(val), [])
            }
        },
        computed: {
            categorizedCoffeeIds: function () {
                let ids = this.categories.map(category =>
                    category.coffees.map(coffee => coffee.id)
                );

                return this.flat(ids);
            },
            exceptedIdsParam: function () {
                return {
                    params: {
                        exceptedIds: this.categorizedCoffeeIds,
                        page: this.page,
                        per: 27
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "./../../styles/variables_home";

    .category-heading {
        font-weight: normal;
        margin-top: 4rem;
    }
    .first-heading {
        margin-top: 0;
    }
    .category-sub-heading {
        text-align: center;
        margin: 0 2rem 1.5rem 2rem;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1.2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @media only screen and (max-width: $max-tablet-width) {
        .first-heading {
            margin-top: 1rem;
        }
        .category-sub-heading {
            margin-bottom: 1rem;
        }
    }
</style>
